import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * コンテンツ表示関連のStore
 */
export const useContentStore = defineStore('content', () => {
  /** プログレス表示 */
  const progress = ref<boolean>(false);
  const progressText = ref<string | undefined>(undefined);

  /**
   * プログレス表示の切り替え
   * @param value
   */
  const setProgress = (enable: boolean, text: string | undefined = undefined): void => {
    progress.value = enable;

    if (enable) {
      progressText.value = text;
    } else {
      progressText.value = undefined;
    }
  };

  /** プログレス表示（通話画面用） */
  const callingProgress = ref<boolean>(false);
  const callingProgressText = ref<string | undefined>(undefined);

  /**
   * プログレス表示の切り替え（通話画面用）
   * @param value
   */
  const setCallingProgress = (enable: boolean, text: string | undefined = undefined): void => {
    callingProgress.value = enable;

    if (enable) {
      callingProgressText.value = text;
    } else {
      callingProgressText.value = undefined;
    }
  };

  /** Snackbar表示 */
  const isShowSnackbar = ref<boolean>(false);

  /** Snackbar メッセージ内容 */
  const snackbarText = ref('');

  /**
   * メッセージを表示する（Snackbar）
   * @param text
   */
  const showMessage = (text: string, isShow: boolean = true): void => {
    snackbarText.value = text;
    isShowSnackbar.value = isShow;
  };

  /** ナビゲーション表示 */
  const drawer = ref<boolean>(false);

  /** ナビゲーション表示の切り替え */
  const toggleDrawer = (): void => {
    drawer.value = !drawer.value;
  };

  /**
   * Storeの初期化
   */
  const clear = (): void => {
    progress.value = false;
    progressText.value = undefined;
    callingProgress.value = false;
    callingProgressText.value = undefined;
    isShowSnackbar.value = false;
    snackbarText.value = '';
    drawer.value = false;
  };

  return {
    progress,
    progressText,
    setProgress,
    callingProgress,
    callingProgressText,
    setCallingProgress,
    isShowSnackbar,
    snackbarText,
    showMessage,
    drawer,
    toggleDrawer,
    clear
  };
});
